// One sell-through rule for the whole page: green 70+ (good), amber 30 to
// under 70 (attention), red under 30 (problem). Status colours only — never
// the brand burgundy.
export type SellThroughLevel = 'good' | 'attention' | 'problem'
export function sellThroughLevel(pct: number): SellThroughLevel {
  return pct >= 70 ? 'good' : pct >= 30 ? 'attention' : 'problem'
}
export const METER_FILL: Record<SellThroughLevel, string> = {
  good: 'bg-[var(--meter-good)]',
  attention: 'bg-[var(--meter-attention)]',
  problem: 'bg-[var(--meter-problem)]',
}
// Coloured TEXT reuses the dark status foregrounds (legible at text size).
export const SELL_THROUGH_TEXT: Record<SellThroughLevel, string> = {
  good: 'text-[var(--status-approved-fg)]',
  attention: 'text-[var(--status-awaiting-fg)]',
  problem: 'text-[var(--status-rejected-fg)]',
}
